(() => {
  const update = () => {
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    } catch { return; }
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const minutes = Number(values.hour) * 60 + Number(values.minute);
    document.querySelectorAll('[data-tx-hours-status]').forEach(status => {
      const saturday = values.weekday === 'Sat';
      const closing = saturday ? Number(status.dataset.saturdayClose.split(':')[0]) * 60 : 1080;
      const sunday = values.weekday === 'Sun';
      const open = !sunday && minutes >= 600 && minutes < closing;
      status.textContent = sunday ? status.dataset.sundayCopy : open ? status.dataset.openCopy : minutes < 600 ? status.dataset.openingCopy : status.dataset.closedCopy;
      status.dataset.state = open ? 'open' : 'closed';
    });
  };
  update();
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  setInterval(update, 60000);
})();

